/*
 * @Date: 2022-05-27 13:20:43
 * @LastEditors: 梦
 * @LastEditTime: 2022-05-27 13:20:44
 * @FilePath: \wine_test\public\tinymce\axupimgs\index.js
 */
require('./plugin.js');